// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__d89_G","sidebarExpanded":"Content_sidebarExpanded__xpcck","sidebarCollapsed":"Content_sidebarCollapsed__Vw7Hm"};